export function SkipLinks() {
  return (
    <>
      <a
        href="#content"
        className="mdc-btn mdc-btn--sm mdc-btn--primary sr-only absolute top-8 left-8 z-50 focus:not-sr-only focus:absolute focus:px-8 focus:py-4"
      >
        Skip to main content
      </a>
    </>
  );
}
